import { Component, OnInit, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { EFormColumn } from '../../e-form-column.model';
import { EFormControl } from '../../e-form-control.model';
import { EFormConfiguration } from '../../e-form-config.model';

@Component({
  selector: 'e-form-viewer-column',
  templateUrl: './e-form-viewer-column.component.html',
  styleUrls: ['./e-form-viewer-column.component.css']
})
export class EFormViewerColumnComponent implements OnInit, AfterViewInit {

  @Input() column: EFormColumn;
  @Input() editable: boolean;
  @Input() disableMergeFields: boolean;
  @Input() print: boolean;
  @Input() showConditionals: boolean;
  @Input() masterId: number;
  @Input() designPageIndex: number;
  @Input() config: EFormConfiguration;
  @Input() topLevel: Boolean = false;
  @Output() viewInitialized: EventEmitter<boolean> = new EventEmitter<boolean>();
  controlViewStatuses: any[] = [];
  rowViewStatuses: any[] = [];
  initialized = false;
  constructor() { 
    const x = this.masterId;
  }

  ngOnInit() {
    this.column.Controls.forEach(control => {
      if (control.Visible) {
        this.controlViewStatuses.push({Id: control.Id, Initialized: false});
      }
    });
    for (let i = 0; i < this.column.Rows.length; i++) {
      this.rowViewStatuses.push({Id: i, Initialized: false});
    }
  }

  ngAfterViewInit() {
    this.initialized = true;
    this.checkInitializedStatus();
  }

  checkInitializedStatus() {
    if(this.topLevel) {
      let filler = 'filler';
    }
    if (this.initialized && this.controlViewStatuses.find(o => o.Initialized == false) == null && this.rowViewStatuses.find(o => o.Initialized == false) == null) {
      if(this.topLevel) {
        let filler = 'filler';
      }
      setTimeout(() => {
        if(this.topLevel) {
          let filler = 'filler';
        }
        this.viewInitialized.emit(true);
      }, 0);
    }
  }

  controlInitialized(control: EFormControl) {
    const status = this.controlViewStatuses.find(o => o.Id == control.Id);
    if (status) {
      status.Initialized = true;
    }
    this.checkInitializedStatus();
  }

  rowInitialized(index: number) {
    const status = this.rowViewStatuses.find(o => o.Id == index);
    if (status) {
      status.Initialized = true;
    }
    this.checkInitializedStatus();
  }

}
